import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MarinaInfo } from '../../interfaces/marina.interface';

export interface MarinaSelectionDialogData {
  accessibleMarinas: MarinaInfo[];
  currentMarinaId: string | null;
}

@Component({
  selector: 'marina-marina-selection-dialog',
  templateUrl: './marina-selection-dialog.component.html',
  styleUrls: ['./marina-selection-dialog.component.scss']
})
export class MarinaSelectionDialogComponent {
  accessibleMarinas: MarinaInfo[] = [];
  currentMarinaId: string | null = null;

  constructor(
    public dialogRef: MatDialogRef<MarinaSelectionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MarinaSelectionDialogData
  ) {
    const list = [...(data?.accessibleMarinas || [])];
    list.sort((a, b) =>
      (a.name || '').localeCompare(b.name || '', undefined, { sensitivity: 'base' })
    );
    this.accessibleMarinas = list;
    this.currentMarinaId = data?.currentMarinaId || null;
  }

  selectMarina(marinaId: string): void {
    this.currentMarinaId = marinaId;
    this.dialogRef.close(marinaId);
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
